import { StaticBaseDao } from '@/dao';
import { TrainingLaneGroup, PostResponse } from '@/objects/generated';

export class TrainingLaneDao extends StaticBaseDao {
    public static async TrainingLanes(EventID: number, uids?: number[], detailed?: boolean): Promise<TrainingLaneGroup[]> {
        return this.BaseFetchArray(
            TrainingLaneGroup,
            `TrainingLane/TrainingLaneGroups` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (uids == undefined ? '' : `${this.makeGetStringFromList(uids, 'uids')}`) +
                '&' +
                (detailed == undefined ? '' : `detailed=${detailed}`),
            'GET',
        );
    }
    public static async Save(EventID: number, trainingLaneGroups: TrainingLaneGroup[]): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `TrainingLane/SaveTrainingLaneGroups` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
            trainingLaneGroups,
        );
    }
}
